const mp4Type = 'video/mp4';
const movType = 'video/mov';

export const checkVideoType = (type: string) => type === mp4Type || type === movType;
